import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getItemsOverQuantity } from 'entities/CatalogItem';
import { CatalogItem } from 'entities/CatalogItem/model/types/CatalogItemSchema';
import { getSelectedOrder } from 'entities/Order/model/selectors/ordersSelectors';

interface UseOrderSubmitUnavailableLabelParams {
    groupedItems: Record<string, CatalogItem[]>;
    isManagerOrPMC: boolean;
    isRequiredPoNumberForOrder: boolean;
    hasLoadingPnA: boolean;
}

export const useOrderSubmitUnavailableLabel = ({
    groupedItems,
    isManagerOrPMC,
    isRequiredPoNumberForOrder,
    hasLoadingPnA,
}: UseOrderSubmitUnavailableLabelParams) => {
    const currentOrder = useSelector(getSelectedOrder);

    return useMemo(() => {
        const flatItems = Object.values(groupedItems).flat();
        const orderLines = currentOrder?.items ?? [];
        const unavailableItemCount = getItemsOverQuantity(
            flatItems,
            orderLines,
        ).length;

        const shouldShowUnavailableLabel =
            isManagerOrPMC &&
            unavailableItemCount > 0 &&
            !isRequiredPoNumberForOrder &&
            !hasLoadingPnA;

        return { unavailableItemCount, shouldShowUnavailableLabel };
    }, [
        groupedItems,
        currentOrder,
        isManagerOrPMC,
        isRequiredPoNumberForOrder,
        hasLoadingPnA,
    ]);
};
